import { Facebook, Instagram, Linkedin, Phone, Mail, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#003946] text-[#FFFFFF] pt-20 pb-10 relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 pb-12 border-b border-[#FFFFFF]/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-5 mb-6">
              <div className="w-20 h-20 rounded-2xl bg-[#FFFFFF] p-1.5 flex items-center justify-center shadow-[0_8px_24px_-8px_rgba(184,147,74,0.5)] ring-1 ring-[#AC9667]/40 shrink-0">
                <img
                  src="https://customer-assets.emergentagent.com/job_serene-home-care-1/artifacts/tqn1isrq_IMG_20251217_193656.jpg"
                  alt="Madison Peaceful Path Home Care"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <p className="font-serif text-xl text-[#FFFFFF] leading-tight">{BRAND.name}</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.28em] text-[#C4B088]">Compassionate · Dependable · Local</p>
              </div>
            </div>
            <p className="text-[#FFFFFF]/70 max-w-md leading-relaxed">
              {BRAND.llc} — providing dignity-focused, non-medical home care across Madison,
              Wisconsin. Built on relationships. Trusted by families. Always.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-link-${i}`}
                  aria-label="Social link"
                  className="w-10 h-10 rounded-full border border-[#FFFFFF]/15 flex items-center justify-center hover:border-[#AC9667] hover:text-[#C4B088] transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="font-serif text-lg mb-4 text-[#C4B088]">Explore</p>
            <ul className="space-y-2.5 text-[#FFFFFF]/75">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="hover:text-[#C4B088] transition-colors text-sm">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-serif text-lg mb-4 text-[#C4B088]">Reach Us</p>
            <ul className="space-y-3 text-[#FFFFFF]/85">
              <li className="flex items-center gap-3 text-sm">
                <Phone className="w-4 h-4 text-[#C4B088]" />
                <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-[#C4B088]">{BRAND.phone}</a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <Mail className="w-4 h-4 text-[#C4B088]" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-[#C4B088] break-all">{BRAND.email}</a>
              </li>
              <li className="flex items-center gap-3 text-sm">
                <MapPin className="w-4 h-4 text-[#C4B088]" />
                <span>Madison, Wisconsin</span>
              </li>
            </ul>
            <p className="mt-6 text-xs italic text-[#FFFFFF]/55 leading-relaxed">
              "Peace of mind, dignity, compassion, professionalism, and dependable support."
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#FFFFFF]/55">
          <p>© {new Date().getFullYear()} {BRAND.llc}. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#C4B088]">Privacy Policy</a>
            <a href="#" className="hover:text-[#C4B088]">Terms of Service</a>
            <a href={`https://${BRAND.domain}`} className="hover:text-[#C4B088]">{BRAND.domain}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
